import { ACTION_TYPES } from "./constants";

const filesReducer = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_FILE_DOWNLOAD_SIGNED_URL_REQUEST_SUCCESS: {
      return {
        ...state,
        [action?.payload?.fileId]: {
          signedUrl: action?.payload?.signedUrl
        }
      };
    }
    default: {
      return state;
    }
  }
};

export default filesReducer;
